import { render, staticRenderFns } from "./CanhBaoHangNgayForm.vue?vue&type=template&id=01a0cc2a&scoped=true&"
import script from "./CanhBaoHangNgayForm.vue?vue&type=script&lang=js&"
export * from "./CanhBaoHangNgayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a0cc2a",
  null
  
)

export default component.exports